module.exports = __webpack_public_path__ + "img/luiz.b6801fbc.jpg";